import React, { useEffect, useState } from "react";
import DashboardNavbar from "./NotWorkArea(Side&Head)/Header/Header";
import SideBar from "./NotWorkArea(Side&Head)/SideBar/SideBar";
import FullRightSide from "./Windows/FullRightSide";
import { InfoAboutClick, SmetaResizeElement } from "../ComponentInterface";
import { Scrollbars } from "react-custom-scrollbars-2";
import cn from "classnames";
import StickyFooter, { HideAllFooterData } from "./NotWorkArea(Side&Head)/Footer";
import { getOptionsForUser, updateOptionsForUser } from "../Url";
import { getIntervalActualVersionWebsite, updateGridData } from "./Tools/Tools";
import SplitterLocal from "./Tools/Splitter";
import { CheckModalBackGrounds } from "../TokenProcessing/TokenProcessing";
import { openHelpContextDialog } from "./NotWorkArea(Side&Head)/Header/SupportButton";
import { useAtomValue } from "jotai";
import { animationsAtom, appConfig, currentTheme, selectedSectionAtom, smetaStore } from "../../atoms";
import { ToastContainer } from "react-toastify";
import { hideToastNotificationsAtom } from "../../atoms";
import { setClientInfo } from "../Singin/SingIn";
import { smetaModals } from "./Tools/modalManager";
import wrapperStyles from "./wrapperMainFile.module.css";
import clsx from "clsx";

export const hideSnow = (show = false) => {
  const enableSnowEffect = smetaStore.get(appConfig).smeta.signOptions?.snowEffect;
  if (show && !enableSnowEffect) return hideSnow();
  const snowflakes = document.querySelector(".snowflakes-box");

  const snowball = document.querySelector(".snowball-box");
  const display = show ? "block" : "none";
  if (snowflakes) snowflakes.style.display = display;
  if (snowball) snowball.style.display = display;
};

export default function WrapperRightSide(props: any) {
  const theme = useAtomValue(currentTheme);
  const animations = useAtomValue(animationsAtom);
  const {
    smeta: { homeOptions },
  } = useAtomValue(appConfig);
  const headerHeight = homeOptions?.header?.height;
  const [selected, setSelected] = useState<InfoAboutClick | undefined>();
  const [selectedEmpty, setSelectedEmpty] = useState<any>(undefined);
  const sideBarSelected = useAtomValue(selectedSectionAtom);
  const [drawerOpen, setdrawerOpen] = useState(
    getOptionsForUser()?.drawerOpen === undefined ? false : getOptionsForUser()?.drawerOpen,
  );
  const hideToastNotifications = useAtomValue(hideToastNotificationsAtom);

  useEffect(() => {
    updateGridData();
    if (sideBarSelected && sideBarSelected.ID !== "") {
      HideAllFooterData(sideBarSelected.ID);
    }
  }, [sideBarSelected]);

  function showMenu() {
    setdrawerOpen(!drawerOpen);
    updateOptionsForUser({ drawerOpen: !drawerOpen });
    if (animations) {
      updateGridData(501);
    } else updateGridData(251);
  }

  function onResizeEnd() {
    updateGridData();
  }

  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);
  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    const key = event.key;
    const keys: { [key: string]: () => void } = {
      F1: openHelpContextDialog,
    };
    if (CheckModalBackGrounds() === 0) {
      if (key in keys) {
        event.preventDefault();
        keys[key]();
      }
    }
    event.stopPropagation();
  };

  useEffect(() => {
    document.title = "Web-Смета";
    hideSnow();
    setClientInfo();
    const handleResize = () => {
      clearTimeout(timer!);
      const timout = setTimeout(() => {
        document.querySelectorAll("[data-smetaresizer]").forEach((el) => {
          if (el.checkVisibility()) (el as SmetaResizeElement).resize();
        });
        smetaModals.refreshMinimizedWindowsPosition(
          Array.from(document.querySelectorAll<HTMLDivElement>(".modalWindow[minimized]")),
        );
        updateGridData();
      }, 250);
      setTimer(timout);
    };
    window.addEventListener("resize", handleResize);
    const intervalGetActualVersionWebsite = getIntervalActualVersionWebsite();
    return () => {
      window.removeEventListener("resize", handleResize);
      clearInterval(intervalGetActualVersionWebsite);
    };
  }, []);

  useEffect(() => {
    if (selectedEmpty !== undefined) {
      setSelected(selectedEmpty);
    }
  }, [selectedEmpty]);

  return (
    <div className={clsx(wrapperStyles["div-wrapper"])} onKeyDown={onKeyDown}>
      <ToastContainer
        limit={5}
        autoClose={60000}
        style={{ visibility: hideToastNotifications ? "hidden" : undefined }}
      />
      <div
        className={clsx(wrapperStyles["div-header-wrapper"])}
        id="Header"
        style={{ height: headerHeight, minHeight: headerHeight }}
      >
        <DashboardNavbar />
      </div>
      <div className={clsx(wrapperStyles["div-workArea-wrapper"])} id="SideBar_FullRightSide">
        <SplitterLocal
          orientation="vertical"
          style={{ width: "100%", height: "100%" }}
          onCollapse={showMenu}
          onExpand={showMenu}
          onResizeEnd={onResizeEnd}
          id="MainSplitter"
          primaryIndex={1}
          sizeSecondary={"245px"}
          collapsed={drawerOpen}
        >
          <div id="CollapsibleSplitterItem" style={{ height: "100%", flex: "1" }}>
            <div
              style={{ height: "34px", display: "flex", alignItems: "center" }}
              id={"SearchBlock"}
              className={clsx("sidebarStimate", { light: theme === "light" })}
            ></div>
            <div
              className={clsx("sidebarStimate", { light: theme === "light" }, wrapperStyles["div-sideBar-wrapper"])}
              id="SideBar"
            >
              <Scrollbars autoHide style={{ overflowX: "hidden" }}>
                <SideBar setSelected={setSelected} emptyjson={selectedEmpty} />
                {/* <NewSideBar/> */}
              </Scrollbars>
            </div>
          </div>

          <div
            className={clsx(
              "backgroundColorStimate",
              {
                light: theme === "light",
              },
              wrapperStyles["div-content-wrapper"],
            )}
            id="FullRightSide"
          >
            <FullRightSide drawerBool={!drawerOpen} />
          </div>
        </SplitterLocal>
      </div>
      <StickyFooter />
    </div>
  );
}
